import React from "react";
import { ColorTool } from '../components/ColorTool';


const ColorToolPage = () => {
    return (
        <div className="App">
            <main className="Content">
                <ColorTool />
            </main>
        </div>
    );
};

export default ColorToolPage;
